module.exports = __webpack_public_path__ + "static/media/icons8-google-cloud - Copy.6411dbc9.svg";